import { getAdminAxiosInstance } from '../../../api/Admin';

export const createPopularSearch = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/popular-search/store`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deletePopularSearch = async (id) => {
  const api = await getAdminAxiosInstance();

  try {
    const response = await api.delete(`/popular-search/delete?search_id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};